<template>
  <TopGradientBlockLayout v-if="dataFetched" fit-content>
    <template v-slot:top v-if="!currentUserIsWatcher">
      <div v-if="!openForm" class="flex items-center justify-between">
        <BaseButton @click="openForm=true"
                    theme="red"
                    class="w-68 lg:w-91">
          {{ $t('createAccount') }}
        </BaseButton>
        <AccountsSpaceSettings/>
      </div>
      <AccountsSettingsForm @accountCreated="updateAccounts" @accountGroupCreated="updateAccounts" v-else/>
    </template>
    <AccountsList :space_sort="current_space.data.account_sort_type"
                  ref="list"
                  @edit="openEditAccountModal"
                  @editGroup="openEditGroupModal"/>
    <transition name="modal">
      <AccountsSettingsEditModal v-if="!!edit_account_item"
                                 :edit_item="edit_account_item"
                                 @close="handleCloseEditAccountModal"/>
      <AccountGroupEditModal v-if="!!group_edit_item"
                             :group="group_edit_item"
                             @close="handleCloseEditAccountGroupModal"/>
    </transition>
  </TopGradientBlockLayout>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";
import AccountsSettingsForm from "@/components/cabinet/SpaceSettings/AccountsSettings/AccountsSettingsForm";
import AccountsSettingsEditModal from "@/components/cabinet/SpaceSettings/AccountsSettings/AccountsSettingsEditModal";
import AccountsList from "@/components/cabinet/SpaceSettings/AccountsSettings/AccountsList";
import AccountGroupEditModal from "@/components/cabinet/SpaceSettings/AccountsSettings/AccountGroupEditModal";
import AccountsSpaceSettings from "@/components/cabinet/SpaceSettings/AccountsSpaceSettings/AccountsSpaceSettings";

export default {
  name: "AccountsSettings",
  components: {
    AccountsSpaceSettings,
    TopGradientBlockLayout,
    BaseButton,
    AccountsSettingsForm,
    AccountsSettingsEditModal,
    AccountGroupEditModal,
    AccountsList,
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('space/accounts', ['accounts', 'account_groups']),
    ...mapGetters('space', ['currentUserIsWatcher']),
  },
  data() {
    return {
      dataFetched: false,
      openForm: false,
      edit_account_item: null,
      group_edit_item: null,
    }
  },
  methods: {
    openEditAccountModal(account) {
      this.edit_account_item = account;
    },
    handleCloseEditAccountModal() {
      this.edit_account_item = null;
      this.updateAccounts();
    },
    handleCloseEditAccountGroupModal() {
      this.group_edit_item = null;
      this.updateAccounts();
    },
    openEditGroupModal(group) {
      this.group_edit_item = group;
    },
    async updateAccounts() {
      await this.$store.dispatch('space/accounts/getAccounts');
      await this.$store.dispatch('space/accounts/getAccountGroups');
      this.$refs['list'].setListing();
    },
    async fetchMainData() {
      try {
        await this.$store.dispatch('space/accounts/getAccounts');
        await this.$store.dispatch('space/accounts/getAccountGroups');
      } catch (e) {
        throw e;
      }
    },
  },
  async created() {
    await this.fetchMainData()
    this.dataFetched = true;
  },
  i18n: {
    messages: {
      en: {
        createAccount: 'Create account'
      },
      ru: {
        createAccount: 'Добавить счет'
      },
    }
  }
}
</script>
